import { Box, Checkbox, TableCell } from '@mui/material'
import { observer } from 'mobx-react'
import React from 'react'
import checkboxStore from '../../../../stores/CheckboxStore'
import store from './RequestsTableOptimizedStore'

type BodyCheckboxProps = {
  row: any
  disabled?: boolean
}

function BodyCheckbox({ row, disabled }: BodyCheckboxProps) {
  const { toggleSelection } = store
  const {
    toggleSelectId,
    selectedIds,
    allIds,
    setIsForbiddenPaymentType,
    isForbiddenPaymentType,
    setForbiddenPaymentCount,
  } = checkboxStore

  const handleClickCheckbox = (e: any, row: any) => {
    e.stopPropagation()
    const wasSelected = selectedIds.includes(row.id)
    !disabled && toggleSelectId(row.id, row.status, row.reportStatus)
    !disabled && toggleSelection(row)

    if ([1, 2, 3, 5].includes(row.financialSourceId) && !disabled) {
      if (!isForbiddenPaymentType && !wasSelected) {
        setIsForbiddenPaymentType(true)
      } else {
        if (wasSelected) {
          setForbiddenPaymentCount('decrement')
        } else {
          setForbiddenPaymentCount('increment')
        }
      }
    }
  }

  const isChecked = selectedIds.includes(row.id)
  const showCheckbox = allIds.includes(row.id)

  return (
    <TableCell sx={{ padding: '8px' }}>
      {showCheckbox ? (
        <Checkbox
          checked={isChecked}
          onClick={(e) => handleClickCheckbox(e, row)}
          sx={{ opacity: disabled ? '.2' : 1 }}
        />
      ) : (
        <Box sx={{ height: '40.5px', width: '40.5px' }} />
      )}
    </TableCell>
  )
}

export default observer(BodyCheckbox)
